import { combineReducers } from 'redux';
import AppReducer from './appReducer';

const reducers = combineReducers({
  AppReducer
});

export default reducers;
